export default __webpack_public_path__ + "static/media/promob.e96d16af.png";